require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-when-loyalty-fails.json") })
        }
      }, "path---news-when-loyalty-fails");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-when-loyalty-fails!./.cache/json/news-when-loyalty-fails.json
// module id = 1441
// module chunks = 231608221292675